
// COURSES COMPONENTS
export const GET_COURSE_COMPONENTS = "/course-components";
export const ADD_NEW_COURSE_COMPONENT = "/course-components";
export const UPDATE_COURSE_COMPONENT = "/course-components";
export const DELETE_COURSE_COMPONENT = "/course-components";


